var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginLeadCaptureLandscapeOld(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 340 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M285.757 20.832H249.713",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6523 156.832H93.0605",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7422 159.665H95.8326",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M292.688 20.832H301.005",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M269.122 18H238.623",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M201.192 168.166H187.329",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M190.103 171H184.558",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3818 20.832H76.4256",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8799 18H84.7429",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5166 18H88.9029",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M267.733 159.665H253.87",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M255.256 156.832H240.721",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M258.03 156.832H259.417",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8359 12.334H37.6085",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M287.143 162.499H289.915",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6768 156.832H32.0631",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8359 156.832H40.3811",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5176 73.2493V70.416",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9035 71.832H86.1309",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M147.126 163.914V161.081",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M148.513 162.498H145.74",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M137.423 15.1663V12.333",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M138.809 13.749H136.036",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M310.71 46.3333C311.475 46.3333 312.096 45.6991 312.096 44.9167C312.096 44.1343 311.475 43.5 310.71 43.5C309.944 43.5 309.323 44.1343 309.323 44.9167C309.323 45.6991 309.944 46.3333 310.71 46.3333Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M312.096 129.917C312.096 129.137 311.472 128.5 310.71 128.5C309.947 128.5 309.323 129.137 309.323 129.917C309.323 130.696 309.947 131.333 310.71 131.333C311.472 131.333 312.096 130.696 312.096 129.917Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2008 88.8333C18.9664 88.8333 19.5871 88.1991 19.5871 87.4167C19.5871 86.6343 18.9664 86 18.2008 86C17.4351 86 16.8145 86.6343 16.8145 87.4167C16.8145 88.1991 17.4351 88.8333 18.2008 88.8333Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2193 3.83332C97.9849 3.83332 98.6056 3.19906 98.6056 2.41666C98.6056 1.63426 97.9849 1 97.2193 1C96.4537 1 95.833 1.63426 95.833 2.41666C95.833 3.19906 96.4537 3.83332 97.2193 3.83332Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M227.533 159.665C228.298 159.665 228.919 159.031 228.919 158.249C228.919 157.466 228.298 156.832 227.533 156.832C226.767 156.832 226.146 157.466 226.146 158.249C226.146 159.031 226.767 159.665 227.533 159.665Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M187.33 20.8317C188.861 20.8317 190.103 19.5632 190.103 17.9984C190.103 16.4336 188.861 15.165 187.33 15.165C185.799 15.165 184.558 16.4336 184.558 17.9984C184.558 19.5632 185.799 20.8317 187.33 20.8317Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M223.371 9.5L226.144 12.3333",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M226.144 9.5L223.371 12.3333",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M316.254 111.501L319.027 114.334",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M319.027 111.501L316.254 114.334",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9746 94.498L23.7472 97.3314",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7472 94.498L20.9746 97.3314",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M312.096 63.334H323.186",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7462 57.666H20.9736",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M314.868 66.167H309.323",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M109.523 111.5H26.8438V151.167H109.523V111.5Z",
    fill: "#D1D1D1"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M103.399 122.832H91.1504V128.499H103.399V122.832Z",
    fill: "#51B8BA"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M103.399 137.001H91.1504V142.668H103.399V137.001Z",
    fill: "#51B8BA"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M109.523 43.5H14.5947V94.4999H109.523V43.5Z",
    fill: "#F1961D"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M109.521 26.501H51.3398V37.8343H109.521V26.501Z",
    fill: "#51B8BA"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M189.14 26.5H137.082C133.7 26.5 130.958 29.037 130.958 32.1666V145.5C130.958 148.629 133.7 151.166 137.082 151.166H189.14C192.522 151.166 195.264 148.629 195.264 145.5V32.1666C195.264 29.037 192.522 26.5 189.14 26.5Z",
    fill: "#51B8BA"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M189.14 26.5H137.082C133.7 26.5 130.958 29.037 130.958 32.1666V145.5C130.958 148.629 133.7 151.166 137.082 151.166H189.14C192.522 151.166 195.264 148.629 195.264 145.5V32.1666C195.264 29.037 192.522 26.5 189.14 26.5Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M192.202 43.5H134.021V134.166H192.202V43.5Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M144.738 121.416H140.145C138.454 121.416 137.083 122.685 137.083 124.249V128.499C137.083 130.064 138.454 131.333 140.145 131.333H144.738C146.43 131.333 147.801 130.064 147.801 128.499V124.249C147.801 122.685 146.43 121.416 144.738 121.416Z",
    stroke: "#51B8BA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M158.516 121.416H153.923C152.231 121.416 150.86 122.685 150.86 124.249V128.499C150.86 130.064 152.231 131.333 153.923 131.333H158.516C160.207 131.333 161.578 130.064 161.578 128.499V124.249C161.578 122.685 160.207 121.416 158.516 121.416Z",
    stroke: "#F1961D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M172.299 121.416H167.706C166.015 121.416 164.644 122.685 164.644 124.249V128.499C164.644 130.064 166.015 131.333 167.706 131.333H172.299C173.99 131.333 175.361 130.064 175.361 128.499V124.249C175.361 122.685 173.99 121.416 172.299 121.416Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M186.077 121.416H181.484C179.793 121.416 178.422 122.685 178.422 124.249V128.499C178.422 130.064 179.793 131.333 181.484 131.333H186.077C187.769 131.333 189.14 130.064 189.14 128.499V124.249C189.14 122.685 187.769 121.416 186.077 121.416Z",
    stroke: "#F1961D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M144.738 97.333H140.145C138.454 97.333 137.083 98.6015 137.083 100.166V104.416C137.083 105.981 138.454 107.25 140.145 107.25H144.738C146.43 107.25 147.801 105.981 147.801 104.416V100.166C147.801 98.6015 146.43 97.333 144.738 97.333Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M158.516 97.333H153.923C152.231 97.333 150.86 98.6015 150.86 100.166V104.416C150.86 105.981 152.231 107.25 153.923 107.25H158.516C160.207 107.25 161.578 105.981 161.578 104.416V100.166C161.578 98.6015 160.207 97.333 158.516 97.333Z",
    stroke: "#51B8BA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M172.299 97.333H167.706C166.015 97.333 164.644 98.6015 164.644 100.166V104.416C164.644 105.981 166.015 107.25 167.706 107.25H172.299C173.99 107.25 175.361 105.981 175.361 104.416V100.166C175.361 98.6015 173.99 97.333 172.299 97.333Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M186.077 97.333H181.484C179.793 97.333 178.422 98.6015 178.422 100.166V104.416C178.422 105.981 179.793 107.25 181.484 107.25H186.077C187.769 107.25 189.14 105.981 189.14 104.416V100.166C189.14 98.6015 187.769 97.333 186.077 97.333Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M144.738 84.583H140.145C138.454 84.583 137.083 85.8515 137.083 87.4163V91.6663C137.083 93.2311 138.454 94.4996 140.145 94.4996H144.738C146.43 94.4996 147.801 93.2311 147.801 91.6663V87.4163C147.801 85.8515 146.43 84.583 144.738 84.583Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M158.516 84.583H153.923C152.231 84.583 150.86 85.8515 150.86 87.4163V91.6663C150.86 93.2311 152.231 94.4996 153.923 94.4996H158.516C160.207 94.4996 161.578 93.2311 161.578 91.6663V87.4163C161.578 85.8515 160.207 84.583 158.516 84.583Z",
    stroke: "#F1961D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M172.299 84.583H167.706C166.015 84.583 164.644 85.8515 164.644 87.4163V91.6663C164.644 93.2311 166.015 94.4996 167.706 94.4996H172.299C173.99 94.4996 175.361 93.2311 175.361 91.6663V87.4163C175.361 85.8515 173.99 84.583 172.299 84.583Z",
    stroke: "#F1961D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M186.077 84.583H181.484C179.793 84.583 178.422 85.8515 178.422 87.4163V91.6663C178.422 93.2311 179.793 94.4996 181.484 94.4996H186.077C187.769 94.4996 189.14 93.2311 189.14 91.6663V87.4163C189.14 85.8515 187.769 84.583 186.077 84.583Z",
    stroke: "#51B8BA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M144.738 71.834H140.145C138.454 71.834 137.083 73.1025 137.083 74.6673V78.9173C137.083 80.4821 138.454 81.7506 140.145 81.7506H144.738C146.43 81.7506 147.801 80.4821 147.801 78.9173V74.6673C147.801 73.1025 146.43 71.834 144.738 71.834Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M158.516 71.834H153.923C152.231 71.834 150.86 73.1025 150.86 74.6673V78.9173C150.86 80.4821 152.231 81.7506 153.923 81.7506H158.516C160.207 81.7506 161.578 80.4821 161.578 78.9173V74.6673C161.578 73.1025 160.207 71.834 158.516 71.834Z",
    stroke: "#51B8BA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M172.299 71.834H167.706C166.015 71.834 164.644 73.1025 164.644 74.6673V78.9173C164.644 80.4821 166.015 81.7506 167.706 81.7506H172.299C173.99 81.7506 175.361 80.4821 175.361 78.9173V74.6673C175.361 73.1025 173.99 71.834 172.299 71.834Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M186.077 71.834H181.484C179.793 71.834 178.422 73.1025 178.422 74.6673V78.9173C178.422 80.4821 179.793 81.7506 181.484 81.7506H186.077C187.769 81.7506 189.14 80.4821 189.14 78.9173V74.6673C189.14 73.1025 187.769 71.834 186.077 71.834Z",
    stroke: "#51B8BA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M144.738 59.083H140.145C138.454 59.083 137.083 60.3515 137.083 61.9163V66.1663C137.083 67.7311 138.454 68.9996 140.145 68.9996H144.738C146.43 68.9996 147.801 67.7311 147.801 66.1663V61.9163C147.801 60.3515 146.43 59.083 144.738 59.083Z",
    stroke: "#51B8BA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M158.516 59.083H153.923C152.231 59.083 150.86 60.3515 150.86 61.9163V66.1663C150.86 67.7311 152.231 68.9996 153.923 68.9996H158.516C160.207 68.9996 161.578 67.7311 161.578 66.1663V61.9163C161.578 60.3515 160.207 59.083 158.516 59.083Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M172.299 59.083H167.706C166.015 59.083 164.644 60.3515 164.644 61.9163V66.1663C164.644 67.7311 166.015 68.9996 167.706 68.9996H172.299C173.99 68.9996 175.361 67.7311 175.361 66.1663V61.9163C175.361 60.3515 173.99 59.083 172.299 59.083Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M186.077 59.083H181.484C179.793 59.083 178.422 60.3515 178.422 61.9163V66.1663C178.422 67.7311 179.793 68.9996 181.484 68.9996H186.077C187.769 68.9996 189.14 67.7311 189.14 66.1663V61.9163C189.14 60.3515 187.769 59.083 186.077 59.083Z",
    stroke: "#F1961D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M144.738 46.334H140.145C138.454 46.334 137.083 47.6025 137.083 49.1673V53.4173C137.083 54.9821 138.454 56.2506 140.145 56.2506H144.738C146.43 56.2506 147.801 54.9821 147.801 53.4173V49.1673C147.801 47.6025 146.43 46.334 144.738 46.334Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M158.516 46.334H153.923C152.231 46.334 150.86 47.6025 150.86 49.1673V53.4173C150.86 54.9821 152.231 56.2506 153.923 56.2506H158.516C160.207 56.2506 161.578 54.9821 161.578 53.4173V49.1673C161.578 47.6025 160.207 46.334 158.516 46.334Z",
    stroke: "#F1961D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M172.299 46.334H167.706C166.015 46.334 164.644 47.6025 164.644 49.1673V53.4173C164.644 54.9821 166.015 56.2506 167.706 56.2506H172.299C173.99 56.2506 175.361 54.9821 175.361 53.4173V49.1673C175.361 47.6025 173.99 46.334 172.299 46.334Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M186.077 46.334H181.484C179.793 46.334 178.422 47.6025 178.422 49.1673V53.4173C178.422 54.9821 179.793 56.2506 181.484 56.2506H186.077C187.769 56.2506 189.14 54.9821 189.14 53.4173V49.1673C189.14 47.6025 187.769 46.334 186.077 46.334Z",
    stroke: "#51B8BA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M156.987 33.582H169.236",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M160.049 36.416H166.173",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M163.112 146.918C165.649 146.918 167.705 145.015 167.705 142.668C167.705 140.321 165.649 138.418 163.112 138.418C160.575 138.418 158.519 140.321 158.519 142.668C158.519 145.015 160.575 146.918 163.112 146.918Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M124.834 40.668H115.647V142.668H124.834V40.668Z",
    fill: "#F1961D"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M124.834 40.6666L120.241 26.5L115.647 40.6666",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M119.322 32.166H122.078",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M118.71 40.668V142.668",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M115.647 40.668V142.668",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M124.835 40.668V142.668",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M121.772 40.668V142.668",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M115.647 145.498V148.331C115.647 149.89 117.025 151.165 118.71 151.165H121.772C123.456 151.165 124.834 149.89 124.834 148.331V145.498",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M124.835 145.499V142.666",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M115.647 145.499V142.666",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M124.834 145.498H115.647",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M124.834 142.666H115.647",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M115.647 40.668H124.834",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M219.762 26.5H201.389V151.166H219.762V26.5Z",
    fill: "#F1961D"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M219.762 26.5H201.389V151.166H219.762V26.5Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M201.389 148.333H204.451",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M201.389 142.667H204.451",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M201.389 137H204.451",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M201.389 131.336H204.451",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M201.389 125.668H204.451",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M201.389 120.003H204.451",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M201.389 114.335H204.451",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M201.389 108.668H204.451",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M201.389 103H204.451",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M201.389 97.3359H204.451",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M201.389 91.667H204.451",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M201.389 86.001H204.451",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M201.389 80.335H204.451",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M201.389 74.6689H204.451",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M201.389 69.001H204.451",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M201.389 63.334H204.451",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M201.389 57.668H204.451",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M201.389 52.001H204.451",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M201.389 46.3359H204.451",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M201.389 40.6699H204.451",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M201.389 35.002H204.451",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M201.389 29.335H204.451",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M201.389 145.498H202.92",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M201.389 139.832H202.92",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M201.389 134.165H202.92",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M201.389 128.5H202.92",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M201.389 122.834H202.92",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M201.389 117.168H202.92",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M201.389 111.5H202.92",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M201.389 105.833H202.92",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M201.389 100.166H202.92",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M201.389 94.501H202.92",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M201.389 88.833H202.92",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M201.389 83.168H202.92",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M201.389 77.501H202.92",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M201.389 71.834H202.92",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M201.389 66.166H202.92",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M201.389 60.499H202.92",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M201.389 54.832H202.92",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M201.389 49.166H202.92",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M201.389 43.499H202.92",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M201.389 37.835H202.92",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M201.389 32.167H202.92",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M216.7 148.334V29.334",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M109.523 26.5H51.3418V37.8333H109.523V26.5Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M97.275 29.334H54.4043V35.0006H97.275V29.334Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M102.632 32.8743C103.477 32.8743 104.163 32.2401 104.163 31.4577C104.163 30.6753 103.477 30.041 102.632 30.041C101.786 30.041 101.101 30.6753 101.101 31.4577C101.101 32.2401 101.786 32.8743 102.632 32.8743Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M103.566 32.5684L105.335 34.1975",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4668 32.167H81.9643",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M85.026 122.831H32.9688V128.498H85.026V122.831Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0312 125.665H72.7775",
    stroke: "#51B8BA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M103.399 122.831H91.1504V128.498H103.399V122.831Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M85.026 137H32.9688V142.667H85.026V137Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0312 139.834H66.6532",
    stroke: "#51B8BA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M103.399 137H91.1504V142.667H103.399V137Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9688 134.166H75.8394",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9688 119.998H75.8394",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M308.565 151.166H225.886V26.5H308.565C313.64 26.5 317.751 30.3037 317.751 35V142.666C317.751 147.363 313.64 151.166 308.565 151.166Z",
    fill: "#51B8BA"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M305.501 26.5H299.377V151.166H305.501V26.5Z",
    fill: "#F1961D"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M308.565 151.166H225.886V26.5H308.565C313.64 26.5 317.751 30.3037 317.751 35V142.666C317.751 147.363 313.64 151.166 308.565 151.166Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M305.502 26.5V151.166",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M299.377 151.166V26.5",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M232.011 26.5V151.166",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M109.523 43.5H14.5947V105.833H109.523V43.5Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5947 94.502H109.523",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M103.4 100.166H20.7207",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M54.402 103C56.0932 103 57.4642 101.731 57.4642 100.166C57.4642 98.6015 56.0932 97.333 54.402 97.333C52.7108 97.333 51.3398 98.6015 51.3398 100.166C51.3398 101.731 52.7108 103 54.402 103Z",
    fill: "#51B8BA"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M54.402 103C56.0932 103 57.4642 101.731 57.4642 100.166C57.4642 98.6015 56.0932 97.333 54.402 97.333C52.7108 97.333 51.3398 98.6015 51.3398 100.166C51.3398 101.731 52.7108 103 54.402 103Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0593 80.3326C68.8241 80.3326 74.3081 75.2585 74.3081 68.9993C74.3081 62.7401 68.8241 57.666 62.0593 57.666C55.2945 57.666 49.8105 62.7401 49.8105 68.9993C49.8105 75.2585 55.2945 80.3326 62.0593 80.3326Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7637 66.168V71.8346L65.8881 69.0013L59.7637 66.168Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M109.523 111.5H26.8438V151.167H109.523V111.5Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M130.958 20.833H167.704",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLeadCaptureLandscapeOld);
export default __webpack_public_path__ + "static/media/login-lead-capture-landscape-old.c43faafa1a329f47433c2c7b56605073.svg";
export { ForwardRef as ReactComponent };